import { render, staticRenderFns } from "./TusPlazasComponent.vue?vue&type=template&id=09127212&scoped=true"
import script from "./TusPlazasComponent.vue?vue&type=script&lang=js"
export * from "./TusPlazasComponent.vue?vue&type=script&lang=js"
import style0 from "./TusPlazasComponent.vue?vue&type=style&index=0&id=09127212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09127212",
  null
  
)

export default component.exports